import { createContext, Dispatch, ReactNode, SetStateAction, useContext, useState } from 'react';
import { QuotationTask } from '@/hooks/api/models';

type Props = {
  children: ReactNode;
};

export type QuotationTaskContextType = {
  quotationTask?: QuotationTask;
  setQuotationTask: Dispatch<SetStateAction<QuotationTask | undefined>>;
}

const QuotationTaskContext = createContext<QuotationTaskContextType>({
  quotationTask: undefined,
  setQuotationTask: () => {
  }
});

export const QuotationTaskProvider = ({ children }: Props) => {
  const [quotationTask, setQuotationTask] = useState<QuotationTask>();

  return (
    <QuotationTaskContext.Provider value={{ quotationTask, setQuotationTask }}>
      {children}
    </QuotationTaskContext.Provider>
  );
};

export const useCurrentQuotationTask = () => {
  return useContext(QuotationTaskContext);
};
